import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    src: String,
    margin: { type: String, default: '800px 0px' }
  }

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load()
    }, { root: this.scrollRoot(), rootMargin: this.marginValue })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  load() {
    this.observer.disconnect()
    this.element.src = this.srcValue
  }

  scrollRoot() {
    let element = this.element.parentElement
    while (element && element !== document.body) {
      if (/(auto|scroll)/.test(getComputedStyle(element).overflowY)) return element
      element = element.parentElement
    }
    return null
  }
}
